import { render, staticRenderFns } from "./PreStorage.vue?vue&type=template&id=65c8a7e0&scoped=true"
import script from "./PreStorage.vue?vue&type=script&lang=js"
export * from "./PreStorage.vue?vue&type=script&lang=js"
import style0 from "./PreStorage.vue?vue&type=style&index=0&id=65c8a7e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8a7e0",
  null
  
)

export default component.exports